import axios from "axios";

let hasSessionExpired = false;
let justAuthenticated = false;

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "development" ? "http://localhost:3000" : "",
});

instance.interceptors.request.use((config) => {
  const remember = localStorage.getItem("remember_me");

  const token =
    remember === "true"
      ? localStorage.getItem("token")
      : sessionStorage.getItem("token");


  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});




instance.interceptors.response.use(
  (response) => {
    hasSessionExpired = false;
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";

    const isPublicEndpoint =
      url.includes("/login") ||
      url.includes("/verify-code") ||
      url.includes("/signup") ||
      url.includes("/whoAmI");

    // ✅ Only logout on whoAmI 401
    if (status === 401 && url.includes("/whoAmI")) {
      console.log("Session expired - redirecting to login");

      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.removeItem("remember_me");

      window.location.href =
        process.env.NODE_ENV === "production" ? "/#/login" : "/login";
    }

    return Promise.reject(error);
  }
);


function getToken() {
  const isPersist = localStorage.getItem("remember_me");

  if (isPersist === "true") {
    return localStorage.getItem("token");
  } else {
    return sessionStorage.getItem("token");
  }
}

const redirectToLogin = (shouldReload = false) => {
  const isProd = process.env.NODE_ENV === "production";

  if (isProd) {
    if (!window.location.hash.includes("#/login")) {
      window.location.href = "/#/login";
    }
  } else {
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
  }

  if (shouldReload) {
    setTimeout(() => {
      window.location.reload();
    }, 100); // wait a short moment to allow redirect
  }
};


export default instance;
